/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import { Typography, makeStyles } from '@material-ui/core';

import IconWhiteChat from '../../assets/images/ic-white-chat.svg';
import IconWhiteMessage from '../../assets/images/ic-white-message.svg';
import IconWhitePhone from '../../assets/images/ic-white-phone.svg';

const useStyles = makeStyles((theme) => {
  return {
    contactContainer: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'flex-start',
      marginBottom: '20px',
    },
    contactParentContainer: {
      margin: 'auto',
      width: '200px',
    },
    container: {
      padding: '0px 30px',
      textAlign: 'center',
    },
    icon: {
      height: 'auto',
      marginRight: '15px',
      width: '24px',
    },
    subtitle: {
      color: '#FFFFFF',
      fontSize: '14px',
      fontWeight: '500px',
      lineHeight: '21px',
      marginBottom: '20px !important',
    },
    text: {
      color: theme.palette.primary.main,
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '24px',
    },
    title: {
      color: '#FFFFFF',
      fontSize: '20px',
      fontWeight: '700',
      lineHeight: '30px',
      marginBottom: '5px !important',
    },
    [theme.breakpoints.up('md')]: {
      contactParentContainer: {
        margin: '0px',
        width: '200px',
      },
      container: {
        textAlign: 'left',
      },
    },
  };
});

export default ({ onChatClick }) => {
  const classes = useStyles();

  const handleChatClick = () => {
    if (!onChatClick || typeof onChatClick !== 'function') return;
    onChatClick();
  };

  return (
    <div className={classes.container}>
      <Typography className={classes.title} level={3}>
        Not sure which to choose?
      </Typography>
      <Typography className={classes.subtitle}>Let our team help you decide</Typography>

      <div className={classes.contactParentContainer}>
        <div className={classes.contactContainer}>
          <img className={classes.icon} src={IconWhiteMessage} alt="icon-message" />
          <Typography className={classes.text}>
            <a className={classes.text} href="mailto:info@mediphany.com">
              info@mediphany.com
            </a>
          </Typography>
        </div>
        <div className={classes.contactContainer}>
          <img className={classes.icon} src={IconWhitePhone} alt="icon-phone" />
          <Typography className={classes.text}>
            <a className={classes.text} href="tel:08886992977">
              (888) 699-2977
            </a>
          </Typography>
        </div>
      </div>
    </div>
  );
};
